import inputData from './inputData/product-research-survey';
import { TemplateItem } from './types';
import { convertDraftParamsToLeadForm } from '../convertDraftParamsToLeadForm';

const previewInput = {
  workspaceId: 'preview-workspace',
  formId: 'preview-form',
  collectionId: 'preview-collection'
};

const template: TemplateItem = {
  id: 'product-research-survey',
  title: 'Product Research Survey',
  description: `Understand your target audience's needs and preferences so you can build a product that truly resonates.`,
  image: '/images/templates/product-research-survey.png',
  tags: ['get-feedback', 'product', 'marketing'],
  inputData: inputData,
  formPreview: convertDraftParamsToLeadForm(inputData(),
    previewInput
  ),
}

export default template;

